
<template>
       <div class="admin-dashboard">
           <AdminDashboard/>
       </div>
</template>

<script>
import AdminDashboard from '../components/Dashboard/AdminDashboard.vue';
export default {
    components: {
        AdminDashboard
    }
};
</script>
<style scoped>
</style>